import {
  GetPartnerEnrollmentStatus,
  IGetPartnerEnrollmentStatusRequest,
  IGetPartnerEnrollmentStatusResponse,
} from '../contracts';
import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import CookieHelper from '../../utils/cookieHelper';
import LogCannon from '@ace-clublabs/log-cannon';

export const GetPartnerEnrollmentStatusApi =
  (endpoint: string): GetPartnerEnrollmentStatus =>
  async (request: IGetPartnerEnrollmentStatusRequest) => {
    const scenario = CookieHelper.getCookie('scenario');

    try {
      let response: AxiosResponse<IGetPartnerEnrollmentStatusResponse>;
      const constructedEndpoint = `${endpoint}/${request.sessionId}`;
      console.log(`requesting session info for ${request.sessionId}`);
      response = await axios
        .get(constructedEndpoint, createAxiosConfig(scenario, endpoint))
        .then((response) => response)
        .catch((e) => e.response);

      LogCannon.blast('GetPartnerEnrollmentStatusApi success');

      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
